/**
 * Refresh scheduler for the T-WIST (`loginUrl` / `oneTimeToken`) login.
 *
 * `scheduleRefreshByToken` from `@tmapy/auth` cannot be used here: its timer dispatches
 * `actionCobraRefreshToken`, which talks to Keycloak and reads the refresh token from a
 * Keycloak-derived localStorage key. Without a `DMX_CONFIG.auth` block it throws.
 */

import type { ParsedJWT } from '@tmapy/auth';
import type { Dispatch } from '@tmapy/redux';

import { actionTwistTokenRefresh, twistLogout } from './actions';

let scheduledRefreshTimeout: ReturnType<typeof setTimeout> | null = null;
let scheduledTime = 0;

export const unscheduleTwistRefresh = () => {
  if (scheduledRefreshTimeout) {
    clearTimeout(scheduledRefreshTimeout);
    scheduledRefreshTimeout = null;
  }
};

export const scheduleTwistRefreshAtTime = (dispatch: Dispatch, time: number) => {
  if (scheduledRefreshTimeout && time >= scheduledTime) return;
  unscheduleTwistRefresh();
  scheduledTime = time;

  const timeout = Math.max(time - Date.now(), 0);
  console.debug(`[AUTH]: T-WIST token refresh after ${timeout / 1000 / 60} minutes`);

  scheduledRefreshTimeout = setTimeout(() => {
    scheduledRefreshTimeout = null;
    dispatch(actionTwistTokenRefresh()).then((refreshed) => {
      if (!refreshed) {
        console.warn('[AUTH]: T-WIST token refresh failed, logging out');
        return dispatch(twistLogout());
      }
    });
  }, timeout);
};

export const scheduleTwistRefreshByToken = (dispatch: Dispatch, parsedToken: ParsedJWT | null) => {
  if (!parsedToken?.payload.exp) return;
  const now = Date.now();
  scheduleTwistRefreshAtTime(dispatch, now + (parsedToken.payload.exp * 1000 - now) / 2);
};
